import { useEffect, useState } from "react";
import "./CategoriaProductos.css";
import { NavLink, useParams, useNavigate } from "react-router-dom";
  const API = process.env.REACT_APP_API_URL

export default function CategoriaProductos() {

  const token = localStorage.getItem("token");
  const [datos, setDatos] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();


  const traerDatos = async () => {
    const response = await fetch(
      `${API}/productos/traerProductosCategoria/${id}`,{
      })
    const data = await response.json();
    setDatos(data.content || []);
  };

  useEffect(() => {
    traerDatos();
  }, [id]);

  return (
    <div className="categoria-page">

      {/* HEADER SIMPLE */}
      <div className="categoria-header">
        <button className="btn-volver" onClick={() => navigate(-1)}>
          ⬅ Volver
        </button>
        <h1 className="categoria-titulo">Productos de la categoría</h1>
      </div>

      {/* GRID PRODUCTOS */}
      <section className="productos-grid">
        {datos.length > 0 ? (
          datos.map(item => (
            <div className="producto-card" key={item.id}>

              <div className="producto-img-wrapper">
                {item.imagenesURLs?.length > 0 && (
                  <img
                    src={`${API}${item.imagenesURLs[0]}`}
                    alt={item.nombre}
                    className="producto-imagen"
                  />
                )}
              </div>

              <div className="producto-info">
                <p className="producto-nombre">{item.nombre}</p>

                <p className="producto-precio">
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                    minimumFractionDigits: 0
                  }).format(item.precio)}
                </p>

                <NavLink to={`/verProducto/${item.id}`} className="btn-ver">
                  Ver detalle
                </NavLink>
              </div>

            </div>
          ))
        ) : (
          <p className="sin-productos">No hay productos en esta categoría</p>
        )}
      </section>

    </div>
  );
}
